export default __webpack_public_path__ + "static/media/refresh.7b3bde4d.svg";